module.exports = __webpack_public_path__ + "static/media/closecircle.9e94ecd4.svg";